<template>
    <Page class="pricing">
        <h1>Pricing</h1>

        <v-simple-table v-if="$vuetify.breakpoint.smAndDown" class="table narrow">
            <thead>
            <tr>
                <th>Open Source</th>
                <th>Pro</th>
                <th>Enterprise</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td colspan="3">Price</td>
            </tr>
            <tr>
                <td>Free forever</td>
                <td>$25/node/month</td>
                <td>Custom</td>
            </tr>
            <template v-for="f in features">
                <tr>
                    <td colspan="3">{{f.name}}</td>
                </tr>
                <tr>
                    <td v-for="i in f.items">
                        <v-icon v-if="i === true" class="icon">mdi-check-bold</v-icon>
                        <v-icon v-else-if="i === false" class="icon" color="error">mdi-close-thick</v-icon>
                        <span v-else-if="i" class="body-2">{{i}}</span>
                    </td>
                </tr>
            </template>
            </tbody>
            <tfoot>
            <tr>
                <td>
                    <router-link :to="{name: 'docs', params: {chapter: 'coroot', group: 'quick-start', item: 'community'}}" class="filled-blue d-block text-no-wrap text-center px-2 body-2 mt-4">Get started</router-link>
                </td>
                <td>
                    <router-link :to="{name: 'cloud'}" class="filled-blue d-block text-no-wrap text-center px-2 body-2 mt-4">Start free trial</router-link>
                </td>
                <td>
                    <ContactUs btn-class="filled-blue d-block text-no-wrap text-center px-2 body-2 mt-4" />
                </td>
            </tr>
            </tfoot>
        </v-simple-table>

        <v-simple-table v-else class="table wide">
            <thead>
            <tr>
                <th></th>
                <th>Open Source</th>
                <th>Pro</th>
                <th>Enterprise</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>Price</td>
                <td class="font-weight-medium">Free forever</td>
                <td class="font-weight-medium">$25/node/month</td>
                <td class="font-weight-medium">Custom</td>
            </tr>
            <tr v-for="f in features">
                <td>{{f.name}}</td>
                <td v-for="i in f.items">
                    <v-icon v-if="i === true" class="icon">mdi-check-bold</v-icon>
                    <v-icon v-else-if="i === false" class="icon" color="error">mdi-close-thick</v-icon>
                    <template v-else-if="i">{{i}}</template>
                </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
                <td></td>
                <td>
                    <router-link :to="{name: 'docs', params: {chapter: 'coroot', group: 'quick-start', item: 'community'}}" class="filled-blue d-block text-no-wrap text-center">Get started</router-link>
                </td>
                <td>
                    <router-link :to="{name: 'cloud'}" class="filled-blue d-block text-no-wrap text-center">Start free trial</router-link>
                </td>
                <td>
                    <ContactUs btn-class="filled-blue d-block text-no-wrap text-center" />
                </td>
            </tr>
            </tfoot>
        </v-simple-table>
    </Page>
</template>

<script>
import Page from "@/pages/Page";
import ContactUs from "@/pages/ContactUs";

export default {
    components: {Page, ContactUs},

    computed: {
        features() {
            return [
                {name: 'Deployment', items: ['Self-hosted', 'Cloud', 'Cloud / On-premises']},
                {name: 'eBPF-based metrics, logs, traces and profiles', items: [true, true, true]},
                {name: 'SLO-tracking', items: [true, true, true]},
                {name: 'Threshold-based inspections', items: [true, true, true]},
                {name: 'Alerting: Slack, PagerDuty, MS Teams, OpsGenie', items: [true, true, true]},
                {name: 'Deployment Tracking', items: [true, true, true]},
                {name: 'Cost Monitoring', items: [true, true, true]},
                {name: 'Continuous Profiling', items: [true, true, true]},
                {name: 'Priority support', items: [false, true, true]},
                {name: 'AI-powered Root Cause Analysis', items: [false, true, true]},
                {name: 'Role-based access control', items: [false, true, true]},
                {name: 'Single sign-on (SSO)', items: [false, false, true]},
            ];
        },
    },

    methods: {
        choosePlan(plan) {
            // localStorage.setItem('plan-chosen', plan);
            this.$st.send('plan-chosen', {plan});
        }
    },
}
</script>

<style scoped>
.pricing {
    font-family: Poppins, sans-serif;
}
.table th {
    color: inherit !important;
    font-size: 20px !important;
    font-weight: 500;
}
.table td {
    font-size: 16px !important;
    width: 20%;
}
.table tr td:first-child {
    width: 40%;
}
.table tfoot td {
    border-top: none !important;
}

.table.narrow th {
    width: 33% !important;
    text-align: center !important;
    font-size: 14px !important;
    padding: 0 8px;
}
.table.narrow td {
    width: 33% !important;
    font-size: 12px !important;
    text-align: center !important;
    border-bottom: none !important;
    border-right: thin solid rgba(0,0,0,.12);
    padding: 0 8px;
}
.table.narrow td:last-child, .table.narrow tfoot td {
    border-right: none;
}
.table.narrow td[colspan] {
    font-weight: 700;
}

.icon {
    color: #4BB649;
    font-size: 20px;
}
</style>
